import { createFileRoute, redirect } from '@tanstack/react-router';

// セッション規定は未提供。左ナビを非活性にしているため、直リンクも SSO 設定へ寄せる。
export const Route = createFileRoute('/_staff/settings/authentication/_layout/settings/session/')({
  beforeLoad() {
    throw redirect({
      to: '/settings/authentication/settings/sso'
    });
  }
});